import { useState } from 'react'
import { Box, Body, Icon, AvatarDialog } from './'
import { assetUrl } from '../../utilities.js'
import './Avatar.scss'

const sizes = {
  largest: 215,
  large: 150,
  medium: 80,
  small: 45,
  smallest: 32
}

export const Avatar = ({ index, onClick, label, selected, onAvatarSelected, edit = false, mode = 'user',
                         labelColor = 'black', labelBackground = 'white', size = 'medium', dark = false,  }) => {
  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false)

  const onAvatarClicked = () => {
    if(edit) {
      setAvatarDialogOpen(true)
    } else if(onClick) {
      onClick()
    }
  }

  return <Box column alignItems="center" className="avatar" container gap={8}>
    {label && <Box
      background={labelBackground}
      color={labelColor}
      radius={50}
      justifyContent="center"
      mb={-16}
      zIndex={2}
      p="2px 4px"
    >
      <Body className="role" alt bold>{label}</Body>
    </Box>}

    <Box
      className={`${((edit || onClick) && !selected) ? `${dark ? 'dark-' : 'light-'}outline-border` : ''} 
        ${selected ? `${dark ? 'dark-' : 'light-'}selected-border` : ''}`}
      height={sizes[size]}
      width={sizes[size]}
      radius="50%"
      onClick={onAvatarClicked}
    >
      {(index !== undefined)
        ? <img alt="avatar" src={assetUrl('avatars/' + mode + '/' + mode + '-avatar-' + index + '.png')}/>
        : <Box
          radius="50%"
          height={sizes[size]}
          width={sizes[size]}
          p={4}
          background="var(--darkgrey)"
          border="1px var(--grey) solid"
          justifyContent="center"
          alignItems="center"
        >
          <Icon fill="black" icon="User" size={sizes[size] / 2} />
        </Box>
      }
      {edit && <Box className="edit-overlay desktop-only" height={sizes[size]} width={sizes[size]}>
        <Icon icon="Edit" size={32}/>
      </Box>}
    </Box>
    {edit && <Body bold underline className="mobile-only" onClick={onAvatarClicked}>Edit</Body>}

    {edit && <AvatarDialog
      value={index}
      mode={mode}
      open={avatarDialogOpen}
      onChange={onAvatarSelected}
      onClose={() => setAvatarDialogOpen(false)}
    />}
  </Box>
}